import React from 'react';
import { useGameState } from './GameEngine';
import { ScoreBar, ResultBanner, ChoicesGrid, UnlockModal } from './GameUI';

export default function Game3({ onUnlock, unlockedLevel, currentLevel, onNav }) {
  const [showUnlock, setShowUnlock] = React.useState(false);

  const game = useGameState(() => setShowUnlock(true));

  return (
    <div className={`game-screen ${game.celebrating ? 'celebrate' : ''}`}>
      <ScoreBar
        score={game.score}
        total={game.total}
        streak={game.streak}
        correctInRow={game.correctInRow}
        levelName="🔢 Niveau 3 – Chiffres"
      />

      <div className="nav-bar">
        {[1,2,3].filter(l => l <= unlockedLevel).map(l => (
          <button key={l} className={`nav-btn ${currentLevel === l ? 'active' : ''}`} onClick={() => onNav(l)}>
            {l === 1 ? '🔵 Cercles' : l === 2 ? '🟥 Barres' : '🔢 Chiffres'}
          </button>
        ))}
      </div>

      <div className="problem-card">
        <div className="instruction">Additionne les deux nombres !</div>
        <div className="big-numbers-row">
          <span className="big-num">{game.numA}</span>
          <span className="big-operator">+</span>
          <span className="big-num">{game.numB}</span>
          <span className="big-operator">=</span>
          <span className="big-question">?</span>
        </div>
      </div>

      <ResultBanner showResult={game.showResult} isCorrect={game.isCorrect} numA={game.numA} numB={game.numB} correct={game.correct} />
      <ChoicesGrid choices={game.choices} selected={game.selected} correct={game.correct} onChoice={game.handleChoice} />

      {showUnlock && (
        <UnlockModal
          hasNext={false}
          onNext={() => { setShowUnlock(false); onNav(1); }}
        />
      )}
    </div>
  );
}
